import { types } from 'mobx-state-tree';
import { v4 as uuid } from 'uuid';

import { PROVINCES, BaseDocument } from '../definitions/Common';
import { QUOTE_STATUSES, QuoteAllocationPriority } from '../definitions/InsCommon';
import { Quote, Metadata } from '../definitions/InsCommon';
import SupportedProvinces from '../definitions/SupportedProvinces';
import Application from './Application';

/**
 * Store which contains the state of our program.
 *
 * idCounter: The id generation is contained in the model stores.
 *            Provides the option of applying a complete model store snapshot
 *            and maintain id integrity. Will prevent id collisions post snapshot.
 */
const InsAutoDocument = BaseDocument
    .named('InsAutoDocument')
    .props({
        id: types.optional(types.identifier, () => uuid()),
        schemaVersion: 9,

        application: Application,
        quotes: types.array(Quote),
        quoteAllocationPriorities: types.array(QuoteAllocationPriority),
        
        province: types.optional(
            types.enumeration(SupportedProvinces), 
            PROVINCES.ONTARIO,
        ),

        dateCreated: types.optional(types.Date, () => new Date()),
        idCounter: 0,

        metadata: types.optional(Metadata, {}),
    })
    .actions(self => ({
        setProvince(province) {
            self.province = province;
        },
        submitQuote(quote) {
            if (!quote || !quote?.id) {
                throw new Error(`[InsAutoDocument.submitQuote] Cannot submit quote inquiry without quote or quote id. Received quote: ${quote}`);
            }

            if (quote.status === QUOTE_STATUSES.SUBMITTED) {
                throw new Error(`[InsAutoDocument.submitQuote] Quote's status has already been submitted ${quote}`);
            }

            const existingQuote = self.quotes.find(storedQuote => storedQuote.id === quote.id);

            if (existingQuote) {
                existingQuote.setStatus(QUOTE_STATUSES.SUBMITTING);
                return;
            }

            self.quotes.push({
                ...quote,
                status: QUOTE_STATUSES.SUBMITTING,
            });
        },
    }));

export default InsAutoDocument;
